export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11887.02a7d0a0.jpg";